import * as d3 from 'd3'

export default {
  data() {
    return {
      pie_data: [],
    }
  },
  methods: {
    drawPieChart() {
      let margin = ({top: 10, right: 10, bottom: 20, left: 10})
      let width = 160
      let height = 85
      var color = d3.scaleOrdinal().range(["#37c97f","#30b2a3","#f8ac2e","#f6775b"])
      let color2 = ["#37c97f","#30b2a3","#f8ac2e","#f6775b"]

      let pie = d3.pie().sort(null).value(d=>{
        for(let i in d){
          if (i.split('_')[0]==='insurance'||i.split('_')[0]==='pay'){
            return d[i]
          }
        }

      }) //对圆的数据进行排序
      let arcs = pie(this.pie_data) // 圆的数据
      // console.log(arcs);
      // 获得数据值的和
      let value_sum = 0
      for (let i=0;i<arcs.length;i++) {
        value_sum += arcs[i].value
      }

      // 圆的大小
      let arc = d3.arc()
        .innerRadius(0)
        .outerRadius(Math.min(width, height) / 2 -10)

      // 修改文字距圆心距离
      let arcLabel = (()=>{
        const radius = Math.min(width, height) / 2 * 0.5
        return d3.arc().innerRadius(radius).outerRadius(radius)
      })()

      var svg = d3.select("#esg_risk_pie_chart").append("svg").attr("viewBox", [0, 0, width, height])
      svg.append("g")
          .attr("stroke", "white")
          .attr("transform", `translate(${width/2},${height/2 + 5})`)
        .selectAll("path")
        .data(arcs)
        .join("path")
          .attr("fill", (d, i)=>{
            if(d.data.esg_ === 'A') return color2[0]
            if(d.data.esg_ === 'B') return color2[1]
            if(d.data.esg_ === 'C') return color2[2]
            if(d.data.esg_ === 'D') return color2[3]
          })
          .attr("d", arc)
        .append("tittle")
          .text(d=>{   
            for(let i in d.data){
              if (i.split('_')[0]==='insurance'||i.split('_')[0]==='pay'){
                return `${d.data.esg_}: ${d.data[i].toLocaleString()}`
              }
            }

          })

      svg.append("g")
        .attr("transform", `translate(${width/2},${height/2 + 5})`)
        .attr("font-family", "sans-serif")
        .attr("font-size", 5)
        .attr("text-anchor", "middle")
        .selectAll("text")
        .data(arcs)
        .join("text")
        .attr("transform", d => {
          let x = arcLabel.centroid(d)[0]
          let y = arcLabel.centroid(d)[1]
          if(d.value / value_sum < 0.05) {
            x *= 2
            y *= 2
          }
          return `translate(${[x,y]})`
        })
        .attr("fill", d=>{
          if(d.value / value_sum < 0.05) return "black"
          return "white"
        })
        .call(text => text.append("tspan")
          .attr("y", "-0.4em")
          .attr("font-weight", "bold")
          .text(d => d.value / value_sum > 0.05? d.data.esg_ : ""))
        .call(text => text.filter(d => (d.endAngle - d.startAngle) > 0.25).append("tspan")
          .attr("x", 0)
          .attr("y", "0.7em")
          .attr("fill-opacity", 0.7)
          .text(d => {
            for(let i in d.data) {
              if(i.split('_')[0]==='insurance'||i.split('_')[0]==='pay') {
                return d.value / value_sum > 0.05?(d.data[i] / value_sum * 100).toLocaleString() + '%' : ""
              }
            }
          }));

    },
    getData(str,e){
      var used_pie = document.querySelector('#esg_risk_pie_chart svg')
      if (used_pie) used_pie.remove()
      let all_data = JSON.parse(window.sessionStorage.getItem('esg_risk'))
      this.pie_data = str ? JSON.parse(all_data[str]) : JSON.parse(all_data.insurance_amount_percentile)
      console.log(this.pie_data);
      if(e){
        let btns = document.getElementsByClassName('pie-change-btn')
        for(let i=0;i<btns.length;i++){
          btns[i].className = "pie-change-btn"
        }
        let btn = e.target
        btn.className = "pie-change-btn pie-change-click"
      }
      this.drawPieChart()
      used_pie = document.querySelector('#esg_risk_pie_chart svg')
    }
  },
  mounted() {
    this.getData()
  }
}



// WEBPACK FOOTER //
// ./src/insurance_esg/js/insurance_esg_pie_chart.js